module.exports = __webpack_public_path__ + "media/sora_flexible_duration.eb45e379.mp4";